<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :md="10" :sm="12">
            <a-form-item label="险种类型">
              <j-dict-select-tag type="list" v-model="queryParam.insuranceType" dictCode="bms_insurance_type" placeholder="请选择险种类型"/>
            </a-form-item>
          </a-col>

          <a-col :md="6" :sm="8">
            <a-form-item label="险种名称" >
              <a-input v-model.trim="queryParam.insuranceName" placeholder="请输入险种名称"></a-input>
            </a-form-item>
          </a-col>

          <a-col :md="4" :sm="8">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus" v-has="'insuranceWithTypeList:add'">新增</a-button>
      <a-button type="primary" icon="download" @click="handleExportXls('险种归属类别表')" v-has="'insuranceWithTypeList:export'">导出</a-button>
      <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel" v-has="'insuranceWithTypeList:import'">
        <a-button type="primary" icon="import" >导入</a-button>
      </a-upload>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择 <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        class="j-table-force-nowrap"
        @change="handleTableChange">

        <span slot="action" slot-scope="text, record">
          <a @click="handleDetail(record)" v-has="'insuranceWithTypeList:detail'">详情</a>
          <a-divider type="vertical" v-has="'insuranceWithTypeList:edit'"/>
          <a @click="handleEdit(record)" v-has="'insuranceWithTypeList:edit'">编辑</a>
          <a-divider type="vertical" v-has="'insuranceWithTypeList:del'"/>
          <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)" v-has="'insuranceWithTypeList:del'">
            <a>删除</a>
          </a-popconfirm>
        </span>

      </a-table>
    </div>

    <biz-insurance-with-type-modal ref="modalForm" @ok="modalFormOk"></biz-insurance-with-type-modal>
  </a-card>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import JDictSelectTag from "@/components/dict/JDictSelectTag"
  import BizInsuranceWithTypeModal from './modules/BizInsuranceWithTypeModal'
  import {filterMultiDictText} from '@/components/dict/JDictSelectUtil'
  import { filterObj } from '@/utils/util'

  export default {
    name: 'BizInsuranceWithTypeList',
    mixins:[JeecgListMixin, mixinDevice],
    components: {
      BizInsuranceWithTypeModal,
      JDictSelectTag,
    },
    data () {
      return {
        description: '险种归属类别列表页面',
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },
          {
            title:'险种名称',
            className:"column-text",
            dataIndex: 'insuranceName'
          },
          {
            title:'险种类型',
            className:"column-text",
            dataIndex: 'insuranceType_dictText'
          },
          {
            title:'备注',
            className:"column-text",
            dataIndex: 'remarks'
          },
          {
            title: '操作',
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:180,
            scopedSlots: { customRender: 'action' }
          }
        ],
        url: {
          list: "/biz/insuranceWithType/list",
          delete: "/biz/insuranceWithType/delete",
          // deleteBatch: "/bms/bizInsuranceWithType/deleteBatch",
          exportXlsUrl: "/biz/insuranceWithType/exportXls",
          importExcelUrl: "biz/insuranceWithType/importExcel",
        },
        dictOptions:{},
      }
    },
    created() {
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
    },
    methods: {
      initDictConfig(){
      },
      getQueryParams(){
        var param = Object.assign({}, this.queryParam, this.isorter ,this.filters)

        // 险种名称
        if(param.insuranceName){
          param.insuranceName = `*${param.insuranceName}*`
        }

        param.pageNo = this.ipagination.current
        param.pageSize = this.ipagination.pageSize
        return filterObj(param);
      },
    }
  }
</script>
<style>
  @import '~@assets/less/common.less';

  th.column-text {
    text-align: center !important;
  }
  td.column-text {
    text-align: left !important;
  }
</style>